// Dependencies
import { all, call, takeEvery, takeLeading, fork, put } from "@redux-saga/core/effects";
import moment from "moment";
// Action Types
import {
    DASHBOARD_PANEL_SEARCH_DEVELOPERS_REQUEST,
    DASHBOARD_PANEL_GADGET_CHART_DATA
} from "Redux/actionTypes";

// Actions
import {
    chartDashboardPanelResponse,
    chartDashboardPanelSearchDevelopersResult,
} from "Redux/actions";

// Helpers
import { clientQuery, clientMutation } from "Core/data/GraphQLApi";
import { endpoints } from "Core/defaultValues";
import { ExceptionManager } from "Core/logManager";

function* chartRequest({ payload }) {
    try {

        const { data } = payload;

        const query = `
            query getGadgetData ($id: String!) {
                result: getGadgetData (id: $id)
            }
        `;

        const response = yield call(
            clientQuery,
            query,
            { id: data.id },
            endpoints.GRAPHQL_GENERAL
        );

        let charts = JSON.parse(response.result);

        yield put(chartDashboardPanelResponse({ data: charts, id: data.id, error: false }));
    } catch (exc) {
        yield put(chartDashboardPanelResponse({ data: [], id: payload.data.id, error: true }));
        ExceptionManager(
            exc,
            "modules/dashboard/views/dashboardPanel/redux/saga",
            "chartRequest"
        );
    }
}

function* searchDevelopers() {
    try {

        let start = moment(moment()).subtract(1, 'months').startOf('month').toDate()
        let end = moment(moment()).subtract(1, 'months').endOf('month').toDate()

        let QUERY = `
            query searchJiraSummary ($dateRange: AWSDateTimeRange!, $developer: String, $jiraTask: String) {
                result: searchJiraSummary (dateRange: $dateRange, developer: $developer, jiraTask: $jiraTask) {
                    name
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                dateRange: { start, end }
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(chartDashboardPanelSearchDevelopersResult(data?.result))

    } catch (exc) {
        yield put(chartDashboardPanelSearchDevelopersResult([]))
        ExceptionManager(
            exc,
            "modules/dashboard/views/dashboardPanel/redux/saga",
            "searchDevelopers"
        );
    }
}

function* watchMethods() {
    yield takeEvery(DASHBOARD_PANEL_GADGET_CHART_DATA, chartRequest);
    yield takeEvery(DASHBOARD_PANEL_SEARCH_DEVELOPERS_REQUEST, searchDevelopers);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}